// Session-level cache for premium status, shared across all usePremiumStatus
// instances. Kept in its own module so Paddle.ts can invalidate it without a
// circular import (Paddle.ts <-> usePremiumStatus.ts).
export const premiumStatusCache: { value: boolean | null } = {
  value: null,
};

// Call after a purchase so the next read re-fetches a fresh token.
export function invalidatePremiumStatusCache(): void {
  premiumStatusCache.value = null;
}
